module.exports = __webpack_public_path__ + "img/svg/background-login-modal.c86ecf54872aa896c2c89500e7ae5a75.svg";